<template>
  <div :class="['search-box', size, className]" @click.stop="$emit('onchange', !isPopup)">
    <div class="label one-txt-cut" :style="{'color': fontColor,}">{{ label }}</div>
    <div class="icon-box">
      <slot name="icon">
        <div class="icon">
          <img
            v-if="size === 'large'"
            :src="fontColor === '#171A1D' ? require('@/assets/refund/icon_BigDown@2x.png') : require('@/assets/refund/ic_jiantou_down@3x.png')"
            alt=""
            srcset=""
          />
          <img
            v-if="size === 'small'"
            :src="fontColor === '#666666' ? require('@/assets/refund/ic_jiantou_down@2x.png') : require('@/assets/refund/ic_jiantou_down@3x.png')"
            alt=""
            srcset=""
          />
        </div>
      </slot>
    </div>

  </div>
</template>

<script>
    export default {
        name: 'SearchBox',
        props: {
          fontColor: {
            type: String,
            default: '#666666'
          },
            className: {
                type: String,
                default: '' // large, small, mini
            },
            size: {
                type: String,
                default: 'small' // large, small, mini
            },
            label: {
                type: String,
                default: ''
            },
            isPopup: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
            };
        },
        model: {
            prop: 'isPopup',
            event: 'onchange'
        },
        methods: {},
        watch: {
        }
    };
</script>

<style lang="less" scoped>
.search-box {
  display: flex;
  //   justify-content: center;
  align-items: center;
}
.large {
  .label {
    height: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 600;
    font-size: 20px;
    color: #171a1d;
    letter-spacing: 0;
    text-align: right;
    // line-height: 20px;
    filter: blur(10);
  }
  .icon {
    margin-left: 3px;
    width: 10px;
    height: 6px;
  }
}

.small {
  .label {
    // width: 48px;
    // height: 14px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    text-align: right;
    // line-height: 12px;
    filter: blur(10);
  }
  .icon {
    margin-left: 5px;
    width: 6px;
    height: 4px;
  }
}
</style>
